import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ramAssistantButton: {
      position: 'fixed',
      zIndex: 1000,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    ramAssistantButtonBK: {
      position: 'fixed',
      zIndex: 1000,
      backgroundColor: theme.palette.brandBKColors.main,
      '&:hover': {
        backgroundColor: theme.palette.brandBKColors.dark,
      },
    },
    ramAssistantButtonPLK: {
      position: 'fixed',
      zIndex: 1000,
      backgroundColor: theme.palette.brandPLKColors.main,
      '&:hover': {
        backgroundColor: theme.palette.brandPLKColors.dark,
      },
    },
    ramAssistantButtonTH: {
      position: 'fixed',
      zIndex: 1000,
      backgroundColor: theme.palette.brandTHColors.main,
      '&:hover': {
        backgroundColor: theme.palette.brandTHColors.dark,
      },
    },
    ramAssistantFloatingContainer: {
      position: 'fixed',
      zIndex: 1001,
      backgroundColor: 'white',
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '8px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      // We control resize via custom handle to force top-left behavior
      resize: 'none',
      maxWidth: 'calc(100vw - 48px)',
      maxHeight: 'calc(100vh - 48px)',
      minWidth: 300,
      minHeight: 200,
    },
    ramAssistantHeader: {
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: 1002,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      padding: '4px',
      borderRadius: '0 8px 0 8px',
    },
    ramAssistantCloseButton: {
      color: 'white',
      padding: '4px',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      },
    },
    ramAssistantIframe: {
      width: '100%',
      height: '100%',
      border: 'none',
      borderRadius: '8px',
    },
    iframeNoPointer: {
      pointerEvents: 'none',
    },
    topLeftResizeHandle: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 16,
      height: 16,
      cursor: 'nwse-resize',
      zIndex: 1003,
      // visual affordance
      background:
        'linear-gradient(135deg, rgba(0,0,0,0.12) 0%, rgba(0,0,0,0.12) 50%, transparent 50%)',
      borderTopLeftRadius: 8,
    },
    loadingOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1004,
      borderRadius: '8px',
    },
    loadingSpinner: {
      color: theme.palette.primary.main,
    },
  }),
);
